import React from 'react';

const CollectorsIcon = () => {
  return (
    <svg viewBox="0 0 19 19">
      <path d="M17.5 0h-16A1.5 1.5 0 0 0 0 1.5v8.34h5.26l1.82-6.36a.86.86 0 0 1 1.66 0l1.94 8.06L12.29 7a.87.87 0 0 1 .71-.56.9.9 0 0 1 .83.44l1.66 3H19V1.5A1.5 1.5 0 0 0 17.5 0zM15 11.56a.86.86 0 0 1-.75-.44l-1-1.75-1.95 5.52a.86.86 0 0 1-.81.57.85.85 0 0 1-.79-.66L7.83 7.09l-1.1 3.85a.86.86 0 0 1-.83.62H0v5.94A1.5 1.5 0 0 0 1.5 19h16a1.5 1.5 0 0 0 1.5-1.5v-5.94h-4z" />
    </svg>
  );
};

export default CollectorsIcon;
